import { useEffect, useRef, useState } from 'react'
import { useFormContext } from 'react-hook-form'

import { MapShape } from '@/feature/map'
import { GEOFENCE_FIELDS, useObservatoryPageStore } from '@/feature/observatory'
import { usePersistentObservatoryPageStore } from '@/feature/observatory/store/usePersistentObservatoryPageStore'

import { GeoFenceTarget } from '../../GeoFenceCreateEdit/components/GeoFenceTarget'
import { GeoFenceShapeFieldProps } from '../../GeoFenceCreateEdit/GeoFenceCreateEdit.types'
import { useUpdateAddressFromSearch } from '../../hooks'

export const CircleGeoFenceShape = ({
  simulatedPosition,
  setSimulatedPosition,
}: GeoFenceShapeFieldProps) => {
  const { watch } = useFormContext()
  const map = useObservatoryPageStore((state) => state.map)
  const setShowSearchMarker = useObservatoryPageStore((state) => state.setShowSearchMarker)
  const searchLocation = usePersistentObservatoryPageStore((state) => state.searchLocation)

  const circleRef = useRef<google.maps.Circle | null>(null)

  const [isTargetHovered, setIsTargetHovered] = useState(false)

  const highRisk = watch(GEOFENCE_FIELDS.highRisk)

  let radiusShapeColor = '#1945B64D'
  if (highRisk) {
    radiusShapeColor = '#FF000040'
  } else if (isTargetHovered) {
    radiusShapeColor = '#45587240'
  }

  useUpdateAddressFromSearch(setSimulatedPosition)

  useEffect(() => {
    if (
      searchLocation &&
      Number.isFinite(searchLocation.location?.lat) &&
      Number.isFinite(searchLocation.location?.lng)
    ) {
      circleRef.current?.setCenter(searchLocation.location)
    }
  }, [searchLocation])

  useEffect(() => {
    setShowSearchMarker(false)
    return () => {
      setShowSearchMarker(true)
    }
  }, [])
  return (
    <>
      {Number.isFinite(simulatedPosition?.location?.lat) &&
      Number.isFinite(simulatedPosition?.location?.lng) &&
      window.google?.maps?.Circle ? (
        <MapShape
          ref={circleRef}
          shape={window.google.maps.Circle}
          parameters={{
            center: simulatedPosition?.location,
            radius: Number.isFinite(watch(GEOFENCE_FIELDS.radius))
              ? watch(GEOFENCE_FIELDS.radius)
              : 0,
            map: map?.map,
            options: {
              strokeWeight: 0,
              fillColor: radiusShapeColor,
              fillOpacity: 1,
            },
          }}
          map={map?.map}
        />
      ) : null}

      <GeoFenceTarget
        isDraggable={true}
        onMove={(v) => {
          if (v) {
            circleRef.current?.setCenter(v)
            setSimulatedPosition({ address: '', location: v.toJSON() })
          }
        }}
        onmouseenter={() => setIsTargetHovered(true)}
        onmouseleave={() => setIsTargetHovered(false)}
      />
    </>
  )
}
